<div class="modal-header">
  <h4 class="modal-title">Edit Scheduled Events Filters</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">

  <div class="form-group clearfix">
    <button type="button" class="btn btn-primary float-right ml-2"
            (click)="handleSubmit()">
      Apply
    </button>
    <button type="button" class="btn btn-secondary float-right"
            (click)="handleClearAll()">
      Clear All
    </button>
  </div>

  <ng-container *ngIf="locationService.getLocations().length > 1">
    <hr>

    <div class="form-group">
      <button type="button" class="btn btn-outline-primary btn-sm float-right"
              (click)="filters.location_id = accountService.getMyAccount().default_gym_id;">
        Clear
      </button>

      <div class="row">
        <div class="col-12 pl-0">
          <label for="location_id">Location</label>

          <select class="custom-select"
                  id="location_id"
                  name="location_id"
                  [(ngModel)]="filters.location_id">
            <option [ngValue]="undefined">All</option>
            <option *ngFor="let location of locationService.getLocations()"
                    [ngValue]="location.id">
              {{ location.name }}
            </option>
          </select>
        </div>
      </div>
    </div>
  </ng-container>

  <hr>

  <div class="form-group">
    <button type="button" class="btn btn-outline-primary btn-sm float-right"
            (click)="filters.event_type_id = undefined;">
      Clear
    </button>

    <div class="row">
      <div class="col-12 pl-0">
        <label for="eventTypeSearchInput">Event Type</label>

        <div *ngIf="filters.event_type_id !== undefined" class="ml-2">
          {{ getSelectedEventType().name }}
          <span *ngIf="getSelectedEventType().status === EventTypeStatus.retired">(Retired)</span>
          -
          <span class="text-danger cursor-pointer" (click)="filters.event_type_id = undefined;">Remove</span>
        </div>
        <input class="form-control" type="text"
               id="eventTypeSearchInput" name="eventTypeSearchInput"
               *ngIf="filters.event_type_id === undefined"
               [(ngModel)]="eventTypeSearchInput"
               [ngbTypeahead]="handleEventTypeTypeahead"
               [inputFormatter]="eventTypeTypeaheadFormatter"
               [resultFormatter]="eventTypeTypeaheadFormatter"
               [editable]="false"
               (selectItem)="filters.event_type_id = $event.item.id;$event.preventDefault();">
      </div>
    </div>
  </div>

  <hr>

  <div class="form-group">
    <button type="button" class="btn btn-outline-primary btn-sm float-right"
            (click)="filters.event_category_id = undefined;">
      Clear
    </button>

    <div class="row">
      <div class="col-12 pl-0">
        <label for="event_category_id">Event Category</label>

        <select class="custom-select"
                id="event_category_id"
                name="event_category_id"
                [(ngModel)]="filters.event_category_id">
          <option [ngValue]="undefined">All</option>
          <option *ngFor="let category of eventCategories"
                  [ngValue]="category.id">
            {{ category.name }}
          </option>
        </select>
      </div>
    </div>
  </div>

  <hr>

  <div class="form-group">
    <button type="button" class="btn btn-outline-primary btn-sm float-right"
            (click)="filters.is_cancelled = undefined;filters.is_private = undefined;">
      Clear
    </button>

    <label>Status</label>

    <div class="form-check">
      <input class="form-check-input" type="radio" name="is_cancelled" id="is_cancelled_true"
             [value]="true" [(ngModel)]="filters.is_cancelled">
      <label class="form-check-label" for="is_cancelled_true">
        Is cancelled
      </label>
    </div>
    <div class="form-check">
      <input class="form-check-input" type="radio" name="is_cancelled" id="is_cancelled_false"
             [value]="false" [(ngModel)]="filters.is_cancelled">
      <label class="form-check-label" for="is_cancelled_false">
        Is not cancelled
      </label>
    </div>

    <div class="form-check mt-2">
      <input class="form-check-input" type="radio" name="is_private" id="is_private_true"
             [value]="true" [(ngModel)]="filters.is_private">
      <label class="form-check-label" for="is_private_true">
        Is private
      </label>
    </div>
    <div class="form-check">
      <input class="form-check-input" type="radio" name="is_private" id="is_private_false"
             [value]="false" [(ngModel)]="filters.is_private">
      <label class="form-check-label" for="is_private_false">
        Is not private
      </label>
    </div>
  </div>

  <hr>

  <div class="form-group">
    <button type="button" class="btn btn-outline-primary btn-sm float-right"
            (click)="filters.has_instructor = undefined;hasSpecificInstructorSelected = false;filters.instructor_id = undefined;filters.instructor_name = undefined;">
      Clear
    </button>

    <div class="row">
      <div class="col-12 pl-0">
        <label>Instructor</label>

        <div class="form-check">
          <input class="form-check-input" type="radio"
                 name="has_instructor" id="has_instructor_false"
                 [checked]="filters.has_instructor === false"
                 (click)="filters.has_instructor = false;hasSpecificInstructorSelected = false;filters.instructor_id = undefined;filters.instructor_name = undefined;">
          <label class="form-check-label" for="has_instructor_false">
            Does not have an instructor
          </label>
        </div>
        <div class="form-check">
          <input class="form-check-input" type="radio"
                 name="has_instructor" id="has_instructor_true"
                 [checked]="filters.has_instructor === true"
                 (click)="filters.has_instructor = true;hasSpecificInstructorSelected = false;filters.instructor_id = undefined;filters.instructor_name = undefined;">
          <label class="form-check-label" for="has_instructor_true">
            Has an instructor
          </label>
        </div>
        <div class="form-check">
          <input class="form-check-input" type="radio"
                 name="hasSpecificInstructorSelected" id="hasSpecificInstructorSelected"
                 [checked]="hasSpecificInstructorSelected"
                 (click)="filters.has_instructor = undefined;hasSpecificInstructorSelected = true;">
          <label class="form-check-label" for="hasSpecificInstructorSelected">
            Has a specific instructor
          </label>
        </div>

        <div class="ml-2 mt-2" *ngIf="hasSpecificInstructorSelected">
          <p *ngIf="filters.instructor_id !== undefined" class="mb-2">
            <b>{{ filters.instructor_name }}</b>
          </p>

          <button class="btn btn-sm btn-outline-primary" type="button"
                  (click)="openSelectInstructorModal()">
            Select Instructor
          </button>
        </div>

        <div class="form-text text-danger" *ngIf="mustSelectInstructorError">
          Please select an instructor.
        </div>
      </div>
    </div>
  </div>

  <hr>

  <div class="form-group">
    <button type="button" class="btn btn-outline-primary btn-sm float-right"
            (click)="filters.booking_capacity = undefined; filters.has_waitlist = undefined;">
      Clear
    </button>

    <div class="row">
      <div class="col-12 pl-0">
        <label for="booking_capacity">Booking Capacity</label>

        <select class="custom-select"
                id="booking_capacity"
                name="booking_capacity"
                [(ngModel)]="filters.booking_capacity">
          <option [ngValue]="undefined">All</option>
          <option [ngValue]="ScheduledEventFilterBookingCapacity.full">
            Fully Booked
          </option>
          <option [ngValue]="ScheduledEventFilterBookingCapacity.notFull">
            Not Fully Booked
          </option>
          <option [ngValue]="ScheduledEventFilterBookingCapacity.halfOrMoreBooked">
            At Least Half Booked
          </option>
          <option [ngValue]="ScheduledEventFilterBookingCapacity.lessThanHalfBooked">
            Less Than Half Booked
          </option>
          <option [ngValue]="ScheduledEventFilterBookingCapacity.atLeastOneBooking">
            At Least One Booking
          </option>
          <option [ngValue]="ScheduledEventFilterBookingCapacity.noBookings">
            No Bookings
          </option>
        </select>
      </div>

      <div *ngIf="!fullBookingCapacityCalculation" class="alert alert-info mt-3">
        This capacity filter will only take into account the event's own capacity limit, and will not reflect shared facility area capacity used by other events. In order to see the fully-calculated capacity, open the individual event's page, or use the
        <a routerLink="/events/scheduled/" target="_blank">Scheduled Events</a>
        page's filters.
      </div>

      <div class="col-12 pl-0">
        <label for="has_waitlist">Waitlist</label>

        <select class="custom-select"
                id="has_waitlist"
                name="has_waitlist"
                [(ngModel)]="filters.has_waitlist">
          <option [ngValue]="undefined">All</option>
          <option [ngValue]="true">
            Has participants on waitlist
          </option>
          <option [ngValue]="false">
            Does not have participant on waitlist
          </option>
        </select>
      </div>
    </div>
  </div>

</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary"
          (click)="handleClearAll()">
    Clear All
  </button>
  <button type="button" class="btn btn-primary"
          (click)="handleSubmit()">
    Apply
  </button>
</div>
